module.exports = __webpack_public_path__ + "static/img/smile3.9355b61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smile3.png
// module id = gAlV
// module chunks = 2